<template lang="">
  <div class="px-2">
    <b-card class="w-100 d-flex rounded-lg">
      <b-row class="pb-2 w-100 d-flex justify-content-between">
        <b-col md="4">
          <v-select
            v-model="filter.experiment_id"
            :dir="'ltr'"
            :options="experiments"
            class="w-100 mb-0"
            :reduce="(val) => val.id"
            placeholder="Experiment"
            :label="'name'"
          >
            <template v-slot:option="option">
              {{ option.name }}
            </template>
            <template #selected-option="{ name }">
              <div style="display: flex; align-items: baseline">
                {{ name }}
              </div>
            </template>
            <template #no-options>
              {{ $t("noMatching") }}
            </template>
          </v-select>
        </b-col>
        <div>
          <b-button
            class="btn rounded-pill"
            variant="primary"
            @click="addVersion()"
          >
            Add Version
          </b-button>
        </div>
      </b-row>
      <center v-if="load">
        <b-spinner
          variant="primary"
          label="Spinning"
        />
      </center>
      <b-row>
        <center
          v-if="!load && items.data.length === 0"
          class="w-100 text-center mr-3"
        >
          <h3>No Data to show</h3>
        </center>
        <b-table
          v-if="!load && items.data && items.data.length > 0"
          id="drag-index"
          :items="items.data"
          :fields="fields"
          striped
          responsive
        >
          <template #cell(id)="data">
            <feather-icon
              v-b-tooltip.hover.top="'Delete'"
              :tooltip="'none'"
              icon="AlignJustifyIcon"
              size="18"
            />
          </template>
          <template #cell(Category)="data">
            <div v-if="data.item.category !=null">
              {{ data.item.category.name }}
            </div>
          </template>
          <template #cell(Actions)="data">

            <div class="d-flex justify-content-start align-items-center">
              <!-- <b-link
                            :to="{ name: 'experiment_details', params: { id: data.item.id } }"
                            class="alert-link cutom-alert-link mr-1"
                            >
                            <feather-icon icon="EyeIcon" size="18" v-b-tooltip.hover.top="'View'" />
                        </b-link> -->

              <b-link
                :tooltip="'none'"
                class="alert-link cutom-alert-link mr-1"
                :to="{ name: 'edit_version', params: { id: data.item.id} }"
              >
                <feather-icon
                  v-b-tooltip.hover.top="'Edit'"
                  :tooltip="'none'"
                  icon="EditIcon"
                  size="18"
                />
              </b-link>
              <b-link
                :tooltip="'none'"
                class="alert-link cutom-alert-link text-danger"
                @click="deleteVersion(data.item.id)"
              >
                <feather-icon
                  v-b-tooltip.hover.top="'Delete'"
                  :tooltip="'none'"
                  icon="Trash2Icon"
                  size="18"
                />
              </b-link>
            </div>
          </template>
        </b-table>
        <!-- Pagination & Per Page -->
        <b-row class="mt-2 w-100 align-items-center" v-if="items && items.meta">
          <b-col md="4" class="text-light d-flex align-items-center" style="font-size: 0.95rem;">
            <span v-if="items.meta.total > 0" class="d-flex align-items-center" style="margin-left: 2px;">
              Showing 
              <b-form-select
                v-model="filter.per_page"
                :options="[10, 25, 50, 100]"
                class="custom-per-page mx-1"
                @change="onPageChange(1)"
              />
            </span>
          </b-col>
          <b-col md="4" class="d-flex justify-content-center">
            <b-pagination
              v-model="items.meta.current_page"
              :total-rows="items.meta.total"
              :per-page="items.meta.per_page"
              @change="onPageChange"
              class="mb-0"
            />
          </b-col>
          <b-col md="4"></b-col>
        </b-row>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { mapGetters } from 'vuex'
import vSelect from 'vue-select'

import {
  BTable,
  BButton,
  BFormCheckbox,
  BCard,
  BRow,
  BCol,
  BBadge,
  BCardText,
  BAvatar,
  VBTooltip,
  BLink,
  BSpinner,
  BPagination,
  BFormSelect,
} from 'bootstrap-vue'

export default {
  name: 'Experiments',
  components: {
    BTable,
    BButton,
    BFormCheckbox,
    BCard,
    BRow,
    BCol,
    BBadge,
    BAvatar,
    BCardText,
    BLink,
    BSpinner,
    BPagination,
    vSelect,
    BFormSelect,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },

  watch: {
    'filter.experiment_id': function (newVal) {
      this.$store.dispatch('versions/list', this.filter).then(res => {

      }).catch(error => {
        if (error.response) {
          this.$swal({
            icon: 'error',
            title: `<h4>${error.response.data.error}</h4>`,
            showConfirmButton: true,
            confirmButtonColor: '#7367f0',
            allowOutsideClick: true,
          })
        }
      })
    },
  },
  computed: {
    ...mapGetters({
      items: 'versions/items',
      experiments: 'experiments/experimentsLookups',
      load: 'experiments/load',
    }),
    category_id() {
      return this.$route.query.id
        ? this.$route.query.id
        : null
    },
  },
  data() {
    return {

      filter: {
        category_id: null,
        per_page: 10,
      },
      trashOptions: [
        { id: 0, name: 'Active' },
        { id: 1, name: 'Inactive' },
      ],
      fields: [
        { key: 'version_number', label: 'Version Number', sortable: true },
        { key: 'experiment_name', label: 'experiment' },
        { key: 'release_date', label: 'release date' },
        { key: 'update_status', label: 'update status', sortable: true },
        { key: 'download_link', label: 'download link' },
        'Actions',
      ],
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    loadData() {
      this.filter.trashed = !this.filter.trashed
      this.init()
    },
    deleteVersion(id) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You want to delete!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel it!',
        confirmButtonColor: '#7367f0',
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('versions/remove', id).then(_ => {
            this.init()
            this.$swal({
              icon: 'success',
              title: 'Deleted!',
              confirmButtonColor: '#7367f0',
            })
          }).catch(error => {
            if (error.response) {
              this.$swal({
                icon: 'error',
                title: `<h4>${error.response.data.error}</h4>`,
                showConfirmButton: true,
                confirmButtonColor: '#7367f0',
                allowOutsideClick: true,
              })
            }
          })
        }
      })
    },
    addVersion() {
      this.$router.push({
        name: 'add_version',
      })
    },
    init() {
      this.$store.dispatch('experiments/experimentLookups').then(res => {
      })
      this.$store.dispatch('versions/list', { page: 1, per_page: this.filter.per_page, ...this.filter }).then(res => {

      }).catch(error => {
        if (error.response) {
          this.$swal({
            icon: 'error',
            title: `<h4>${error.response.data.error}</h4>`,
            showConfirmButton: true,
            confirmButtonColor: '#7367f0',
            allowOutsideClick: true,
          })
        }
      })
    },

    onPageChange(page) {
      this.$store
        .dispatch('versions/list', { page, per_page: this.filter.per_page, ...this.filter })
    },
    addModule() {
      this.$router.push({ name: 'add_module' })
    },
    refreshData() {
      this.$store
        .dispatch('experiments/list', { page: this.items.current_page })
    },
    deleteModule(id) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You want to delete!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel it!',
        confirmButtonColor: '#7367f0',
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('modules/remove', id).then(_ => {
            this.refreshData()
            this.$swal({
              icon: 'success',
              title: 'Deleted!',
              confirmButtonColor: '#7367f0',
            })
          }).catch(error => {
            if (error.response) {
              this.$swal({
                icon: 'error',
                title: `<h4>${error.response.data.error}</h4>`,
                showConfirmButton: true,
                confirmButtonColor: '#7367f0',
                allowOutsideClick: true,
              })
            }
          })
        }
      })
    },
    hardDeleteModule(id) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You want to hard delete!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel it!',
        confirmButtonColor: '#7367f0',
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('modules/hardRemove', id).then(_ => {
            this.init()
            this.$swal({
              icon: 'success',
              title: 'Deleted!',
              confirmButtonColor: '#7367f0',
            })
          }).catch(error => {
            if (error.response) {
              this.$swal({
                icon: 'error',
                title: `<h4>${error.response.data.error}</h4>`,
                showConfirmButton: true,
                confirmButtonColor: '#7367f0',
                allowOutsideClick: true,
              })
            }
          })
        }
      })
    },

  },
}
</script>
<style lang="scss">

</style>
